import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, inject, HostBinding, Input, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { SharedModule } from 'primeng/api';
import { BaseComponent } from 'primeng/basecomponent';
import { BaseStyle } from 'primeng/base';

const classes = {
    root: 'p-avatar-group p-component'
};
class AvatarGroupStyle extends BaseStyle {
    name = 'avatargroup';
    classes = classes;
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AvatarGroupStyle, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AvatarGroupStyle });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AvatarGroupStyle, decorators: [{
            type: Injectable
        }] });
/**
 *
 * A set of Avatars can be displayed together using the AvatarGroup component.
 *
 * [Live Demo](https://www.primeng.org/avatar/)
 *
 * @module avatargroupstyle
 *
 */
var AvatarGroupClasses;
(function (AvatarGroupClasses) {
    AvatarGroupClasses["root"] = "p-avatar-group";
})(AvatarGroupClasses || (AvatarGroupClasses = {}));

/**
 * AvatarGroup is a helper component for Avatar.
 * @group Components
 */
class AvatarGroup extends BaseComponent {
    /**
     * Style class of the component
     * @group Props
     */
    styleClass;
    /**
     * Inline style of the component.
     * @group Props
     */
    style;
    get hostClass() {
        return this.styleClass;
    }
    get hostStyle() {
        return this.style;
    }
    _componentStyle = inject(AvatarGroupStyle);
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AvatarGroup, deps: null, target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "19.2.10", type: AvatarGroup, isStandalone: true, selector: "p-avatarGroup, p-avatar-group, p-avatargroup", inputs: { styleClass: "styleClass", style: "style" }, host: { properties: { "class.p-avatar-group": "true", "class.p-component": "true", "class": "this.hostClass", "style": "this.hostStyle" } }, providers: [AvatarGroupStyle], usesInheritance: true, ngImport: i0, template: ` <ng-content></ng-content> `, isInline: true, dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: SharedModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AvatarGroup, decorators: [{
            type: Component,
            args: [{
                    selector: 'p-avatarGroup, p-avatar-group, p-avatargroup',
                    standalone: true,
                    imports: [CommonModule, SharedModule],
                    template: ` <ng-content></ng-content> `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None,
                    providers: [AvatarGroupStyle],
                    host: {
                        '[class.p-avatar-group]': 'true',
                        '[class.p-component]': 'true'
                    }
                }]
        }], propDecorators: { styleClass: [{
                type: Input
            }], style: [{
                type: Input
            }], hostClass: [{
                type: HostBinding,
                args: ['class']
            }], hostStyle: [{
                type: HostBinding,
                args: ['style']
            }] } });
class AvatarGroupModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AvatarGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: AvatarGroupModule, imports: [AvatarGroup, SharedModule], exports: [AvatarGroup, SharedModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AvatarGroupModule, imports: [AvatarGroup, SharedModule, SharedModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: AvatarGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [AvatarGroup, SharedModule],
                    exports: [AvatarGroup, SharedModule]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AvatarGroup, AvatarGroupClasses, AvatarGroupModule, AvatarGroupStyle };
